import React, { useState } from 'react';
import Modal from './Modal';
import WhatsappIcon from '../../images/inline/we-chat.inline.svg';
import ChatPerson1 from '../../images/chat-person-1.png';
import ChatPerson2 from '../../images/chat-person.png';
import BaseText from '../ui/typography/BaseText';
import WeChatQrCode from '../../images/air-corporate-we-chat.png';
export default function WhatsappModal({ iconOnly, fill }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div>
      {!iconOnly ? (
        <div
          onClick={handleOpenModal}
          className="w-3/5 mt-6 mx-auto chat-button flex items-center justify-between border border-blue-500 rounded-lg text-blue-500 py-2 px-3 cursor-pointer hover:bg-blue-500 hover:text-white"
        >
          <div className="flex">
            <img
              src={ChatPerson1}
              className="w-10 h-10 rounded-full border border-white"
              alt="chat-person"
              height={40}
              width={40}
            />
            <img
              className="-ml-2 w-10 h-10 rounded-full border border-white"
              src={ChatPerson2}
              alt="chat-person"
              height={40}
              width={40}
            />
          </div>{' '}
          Chat with us <WhatsappIcon />
        </div>
      ) : (
        <div onClick={handleOpenModal} className="cursor-pointer">
          <WhatsappIcon fill={fill} />
        </div>
      )}

      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <BaseText title="扫码加微信" />
        <BaseText textColor="text-gray-200" title="Add us on Wechat!" />
        <img className="mx-auto my-4" src={WeChatQrCode} alt="whatsapp-qr-code" height={320} width={320} />
      </Modal>
    </div>
  );
}

WhatsappModal.defaultProps = {
  iconOnly: true
};
